module.exports = __webpack_public_path__ + "img/down_arrow.ebfb0de4.svg";